import * as CONST from './const'

/**
 * Get pickup times by city id
 *
 * @param cityId
 */
export function getPickupTimesByCityId(cityId) {
  return {
    type: CONST.GET_PICKUP_TIMES_BY_CITY_ID,
    cityId,
  }
}

/**
 * Add new pickup time
 *
 * @param payload
 */
export function addPickupTime(payload) {
  return {
    type: CONST.ADD_PICKUP_TIME,
    payload,
  }
}

/**
 * Remove pickup time
 *
 * @param payload
 */
export function removePickupTime(payload) {
  return {
    type: CONST.REMOVE_PICKUP_TIME,
    payload,
  }
}

/**
 * Cancel new pickup times
 *
 * @param payload
 */
export function cancelPickupTime() {
  return {
    type: CONST.CANCEL_PICKUP_TIME,
  }
}

/**
 * Save pickup times list
 *
 * @param payload
 */
export function savePickupTimesList(payload) {
  return {
    type: CONST.SAVE_PICKUP_TIMES_LIST,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/PickupTimes/actions.js